import React, { createContext, useContext, useState, useEffect } from "react";
import Cookies from "js-cookie";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    isLoggedIn: false,
    user: null,
    token: null,
  });

  // 🔄 Load session from cookie or sessionStorage on first render
  useEffect(() => {
    const savedToken = Cookies.get("token") || sessionStorage.getItem("token");
    const savedUser = sessionStorage.getItem("user");

    if (savedToken && savedUser) {
      setAuth({
        isLoggedIn: true,
        token: savedToken,
        user: JSON.parse(savedUser),
      });
    }
  }, []);

  // 🔑 Login function (after API call success)
  const login = (userData, token) => {
    setAuth({ isLoggedIn: true, user: userData, token });

    // Save in sessionStorage
    sessionStorage.setItem("user", JSON.stringify(userData));
    sessionStorage.setItem("token", token);

    // Also save in cookie (optional)
    Cookies.set("token", token, { expires: 7, path: "/" });
  };

  // 🚪 Logout function
  const logout = () => {
    setAuth({ isLoggedIn: false, user: null, token: null });
    sessionStorage.clear();
    Cookies.remove("token");
  };

  return (
    <AuthContext.Provider value={{ auth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
